import { useCallback, useState } from 'react';
import { adminGetUser } from 'services/admin';
import { User } from '../app/pages/UserPage/type';

export type UserSelectOption = {
  label: string;
  value: string;
  email?: string;
  role?: string;
  accessibleClients?: User['accessibleClients'];
  viewAccess?: string[];
  editAccess?: string[];
};

export const useGetUser = () => {
  const [users, setUsers] = useState<UserSelectOption[]>([]);
  const getUsers = useCallback(async (page = 1) => {
    const params = {
      size: 200,
      page
    };
    const data = (await adminGetUser(params)) as { users: User[] };
    setUsers(
      data.users
        .map((item) => ({
          label: item.name,
          value: item.id.toString(),
          email: item.email,
          role: item.role,
          accessibleClients: item.accessibleClients,
          viewAccess: item.viewAccess,
          editAccess: item.editAccess
        }))
        .sort((a, b) =>
          (a.label ?? '').localeCompare(b.label ?? '', undefined, { sensitivity: 'base' })
        )
    );
  }, []);
  return {
    users,
    getUsers
  };
};
